export const args = {
    label: 'Total credit limit',
    info: '30,000',
    actionLabel: 'Confirm & get OTP',
    onPress: () => { },
};
export const argTypes = {
    onPress: { action: 'clicked' },
};
